module.exports = __webpack_public_path__ + "img/DynamoDB.941ded39.png";